/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddDocumentoOperatorePraticaDTO } from '../model/addDocumentoOperatorePraticaDTO';
import { AggiornamentoContributoDTO } from '../model/aggiornamentoContributoDTO';
import { CittadinoTransazioniDTO } from '../model/cittadinoTransazioniDTO';
import { ComunicazioniPraticaDTO } from '../model/comunicazioniPraticaDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { NuovaPraticaResultDTO } from '../model/nuovaPraticaResultDTO';
import { PagePratica } from '../model/pagePratica';
import { Pratica } from '../model/pratica';
import { PraticheStatsDTO } from '../model/praticheStatsDTO';
import { RichiestaPraticaDTO } from '../model/richiestaPraticaDTO';
import { RichiestaPraticaStatus } from '../model/richiestaPraticaStatus';
import { TipoRicezioneOTP } from '../model/tipoRicezioneOTP';
import { TipologiaPratica } from '../model/tipologiaPratica';
import { UpdateElementoNucleoDTO } from '../model/updateElementoNucleoDTO';
import { UpdateStatoPraticaDTO } from '../model/updateStatoPraticaDTO';
import { ValueDTO } from '../model/valueDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PraticheControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Consente di aggiungere un documento operatore ad una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param note 
     * @param documentoOperatore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocumentiOperatorePraticaForm(id_slug_comune: string, codicePratica: string, note?: AddDocumentoOperatorePraticaDTO, documentoOperatore?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public addDocumentiOperatorePraticaForm(id_slug_comune: string, codicePratica: string, note?: AddDocumentoOperatorePraticaDTO, documentoOperatore?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public addDocumentiOperatorePraticaForm(id_slug_comune: string, codicePratica: string, note?: AddDocumentoOperatorePraticaDTO, documentoOperatore?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public addDocumentiOperatorePraticaForm(id_slug_comune: string, codicePratica: string, note?: AddDocumentoOperatorePraticaDTO, documentoOperatore?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addDocumentiOperatorePratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling addDocumentiOperatorePratica.');
        }



        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (note !== undefined) {
            formParams = formParams.append('note', <any>note) as any || formParams;
        }
        if (documentoOperatore !== undefined) {
            formParams = formParams.append('documentoOperatore', <any>documentoOperatore) as any || formParams;
        }

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/addDocumentoOperatore`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiungere una nota alla pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addNotaPratica(body: ValueDTO, id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public addNotaPratica(body: ValueDTO, id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public addNotaPratica(body: ValueDTO, id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public addNotaPratica(body: ValueDTO, id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addNotaPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addNotaPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling addNotaPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Pratica>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/note/add`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiungere una nuova richiesta per una determinata pratica
     * 
     * @param id_slug_comune 
     * @param pratica 
     * @param documentoAnagrafica1 
     * @param documentoAnagrafica2 
     * @param documentoAnagrafica3 
     * @param documentoAnagrafica4 
     * @param documentoAnagrafica5 
     * @param documento1 
     * @param documento2 
     * @param documento3 
     * @param documento4 
     * @param documento5 
     * @param documento6 
     * @param documento7 
     * @param documento8 
     * @param documento9 
     * @param documento10 
     * @param screenPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addPraticAuthForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe?: 'body', reportProgress?: boolean): Observable<NuovaPraticaResultDTO>;
    public addPraticAuthForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NuovaPraticaResultDTO>>;
    public addPraticAuthForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NuovaPraticaResultDTO>>;
    public addPraticAuthForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addPraticAuth.');
        }


















        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (pratica !== undefined) {
            formParams = (formParams as FormData).append('pratica', new Blob([JSON.stringify(pratica)], { type: 'application/json'})) as any || formParams;
        }
        if (documentoAnagrafica1 !== undefined) {
            formParams = formParams.append('documentoAnagrafica1', <any>documentoAnagrafica1) as any || formParams;
        }
        if (documentoAnagrafica2 !== undefined) {
            formParams = formParams.append('documentoAnagrafica2', <any>documentoAnagrafica2) as any || formParams;
        }
        if (documentoAnagrafica3 !== undefined) {
            formParams = formParams.append('documentoAnagrafica3', <any>documentoAnagrafica3) as any || formParams;
        }
        if (documentoAnagrafica4 !== undefined) {
            formParams = formParams.append('documentoAnagrafica4', <any>documentoAnagrafica4) as any || formParams;
        }
        if (documentoAnagrafica5 !== undefined) {
            formParams = formParams.append('documentoAnagrafica5', <any>documentoAnagrafica5) as any || formParams;
        }
        if (documento1 !== undefined) {
            formParams = formParams.append('documento1', <any>documento1) as any || formParams;
        }
        if (documento2 !== undefined) {
            formParams = formParams.append('documento2', <any>documento2) as any || formParams;
        }
        if (documento3 !== undefined) {
            formParams = formParams.append('documento3', <any>documento3) as any || formParams;
        }
        if (documento4 !== undefined) {
            formParams = formParams.append('documento4', <any>documento4) as any || formParams;
        }
        if (documento5 !== undefined) {
            formParams = formParams.append('documento5', <any>documento5) as any || formParams;
        }
        if (documento6 !== undefined) {
            formParams = formParams.append('documento6', <any>documento6) as any || formParams;
        }
        if (documento7 !== undefined) {
            formParams = formParams.append('documento7', <any>documento7) as any || formParams;
        }
        if (documento8 !== undefined) {
            formParams = formParams.append('documento8', <any>documento8) as any || formParams;
        }
        if (documento9 !== undefined) {
            formParams = formParams.append('documento9', <any>documento9) as any || formParams;
        }
        if (documento10 !== undefined) {
            formParams = formParams.append('documento10', <any>documento10) as any || formParams;
        }
        if (screenPratica !== undefined) {
            formParams = formParams.append('screenPratica', <any>screenPratica) as any || formParams;
        }

        return this.httpClient.request<NuovaPraticaResultDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/auth/add`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiungere una nuova richiesta per una determinata pratica
     * 
     * @param id_slug_comune 
     * @param pratica 
     * @param documentoAnagrafica1 
     * @param documentoAnagrafica2 
     * @param documentoAnagrafica3 
     * @param documentoAnagrafica4 
     * @param documentoAnagrafica5 
     * @param documento1 
     * @param documento2 
     * @param documento3 
     * @param documento4 
     * @param documento5 
     * @param documento6 
     * @param documento7 
     * @param documento8 
     * @param documento9 
     * @param documento10 
     * @param screenPratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addPraticaForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe?: 'body', reportProgress?: boolean): Observable<NuovaPraticaResultDTO>;
    public addPraticaForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NuovaPraticaResultDTO>>;
    public addPraticaForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NuovaPraticaResultDTO>>;
    public addPraticaForm(id_slug_comune: string, pratica?: RichiestaPraticaDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, screenPratica?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addPratica.');
        }


















        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (pratica !== undefined) {
            formParams = (formParams as FormData).append('pratica', new Blob([JSON.stringify(pratica)], { type: 'application/json'})) as any || formParams;
        }
        if (documentoAnagrafica1 !== undefined) {
            formParams = formParams.append('documentoAnagrafica1', <any>documentoAnagrafica1) as any || formParams;
        }
        if (documentoAnagrafica2 !== undefined) {
            formParams = formParams.append('documentoAnagrafica2', <any>documentoAnagrafica2) as any || formParams;
        }
        if (documentoAnagrafica3 !== undefined) {
            formParams = formParams.append('documentoAnagrafica3', <any>documentoAnagrafica3) as any || formParams;
        }
        if (documentoAnagrafica4 !== undefined) {
            formParams = formParams.append('documentoAnagrafica4', <any>documentoAnagrafica4) as any || formParams;
        }
        if (documentoAnagrafica5 !== undefined) {
            formParams = formParams.append('documentoAnagrafica5', <any>documentoAnagrafica5) as any || formParams;
        }
        if (documento1 !== undefined) {
            formParams = formParams.append('documento1', <any>documento1) as any || formParams;
        }
        if (documento2 !== undefined) {
            formParams = formParams.append('documento2', <any>documento2) as any || formParams;
        }
        if (documento3 !== undefined) {
            formParams = formParams.append('documento3', <any>documento3) as any || formParams;
        }
        if (documento4 !== undefined) {
            formParams = formParams.append('documento4', <any>documento4) as any || formParams;
        }
        if (documento5 !== undefined) {
            formParams = formParams.append('documento5', <any>documento5) as any || formParams;
        }
        if (documento6 !== undefined) {
            formParams = formParams.append('documento6', <any>documento6) as any || formParams;
        }
        if (documento7 !== undefined) {
            formParams = formParams.append('documento7', <any>documento7) as any || formParams;
        }
        if (documento8 !== undefined) {
            formParams = formParams.append('documento8', <any>documento8) as any || formParams;
        }
        if (documento9 !== undefined) {
            formParams = formParams.append('documento9', <any>documento9) as any || formParams;
        }
        if (documento10 !== undefined) {
            formParams = formParams.append('documento10', <any>documento10) as any || formParams;
        }
        if (screenPratica !== undefined) {
            formParams = formParams.append('screenPratica', <any>screenPratica) as any || formParams;
        }

        return this.httpClient.request<NuovaPraticaResultDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di generare le comunicazioni relative al voucher di una pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comunicazioneVoucher(body: Array<string>, id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public comunicazioneVoucher(body: Array<string>, id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public comunicazioneVoucher(body: Array<string>, id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public comunicazioneVoucher(body: Array<string>, id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling comunicazioneVoucher.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling comunicazioneVoucher.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling comunicazioneVoucher.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/voucher/comunica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di generare le comunicazioni relative ai voucher per le pratiche ammesse/finanziate
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public comunicazioniVouchers(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public comunicazioniVouchers(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public comunicazioniVouchers(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public comunicazioniVouchers(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling comunicazioniVouchers.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/vouchers/comunica`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di confermare la pratica inviando il codice otp una nuova richiesta per una determinata pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param otp 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public confermaOtpPratica(id_slug_comune: string, codicePratica: string, otp: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public confermaOtpPratica(id_slug_comune: string, codicePratica: string, otp: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public confermaOtpPratica(id_slug_comune: string, codicePratica: string, otp: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public confermaOtpPratica(id_slug_comune: string, codicePratica: string, otp: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling confermaOtpPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling confermaOtpPratica.');
        }

        if (otp === null || otp === undefined) {
            throw new Error('Required parameter otp was null or undefined when calling confermaOtpPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (otp !== undefined && otp !== null) {
            queryParameters = queryParameters.set('otp', <any>otp);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/conferma-otp`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di confermare la correttezza del pdf review di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public confermaPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public confermaPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public confermaPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public confermaPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling confermaPdfReviewPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling confermaPdfReviewPratica.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/conferma-pdf-review`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di scaricare il voucher relativo ad una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadVoucherCittadino(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadVoucherCittadino(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadVoucherCittadino(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadVoucherCittadino(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling downloadVoucherCittadino.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling downloadVoucherCittadino.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/voucherFile`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di abilitare/disabilitare un elemento del nucleo familiare. Quando fatto vengono ricalcolati anche i punteggi ed importi pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idElementoNucleo 
     * @param enable 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public enableDisableElementoNucleoFamiliare(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, enable: boolean, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public enableDisableElementoNucleoFamiliare(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, enable: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public enableDisableElementoNucleoFamiliare(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, enable: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public enableDisableElementoNucleoFamiliare(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, enable: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling enableDisableElementoNucleoFamiliare.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling enableDisableElementoNucleoFamiliare.');
        }

        if (idElementoNucleo === null || idElementoNucleo === undefined) {
            throw new Error('Required parameter idElementoNucleo was null or undefined when calling enableDisableElementoNucleoFamiliare.');
        }

        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling enableDisableElementoNucleoFamiliare.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enable !== undefined && enable !== null) {
            queryParameters = queryParameters.set('enable', <any>enable);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/elementoNucleo/${encodeURIComponent(String(idElementoNucleo))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di abilitare/disabilitare un elemento del nucleo familiare. Quando fatto vengono ricalcolati anche i punteggi ed importi pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param enable 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public enableDisableNucleoMonogenitorialeFlag(id_slug_comune: string, codicePratica: string, enable: boolean, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public enableDisableNucleoMonogenitorialeFlag(id_slug_comune: string, codicePratica: string, enable: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public enableDisableNucleoMonogenitorialeFlag(id_slug_comune: string, codicePratica: string, enable: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public enableDisableNucleoMonogenitorialeFlag(id_slug_comune: string, codicePratica: string, enable: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling enableDisableNucleoMonogenitorialeFlag.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling enableDisableNucleoMonogenitorialeFlag.');
        }

        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling enableDisableNucleoMonogenitorialeFlag.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enable !== undefined && enable !== null) {
            queryParameters = queryParameters.set('enable', <any>enable);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/nucleoMonogenitoriale`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di abilitare/disabilitare il voucher relativo alla pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param codiceVoucher 
     * @param enable 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public enableDisableVoucherPratica(id_slug_comune: string, codicePratica: string, codiceVoucher: string, enable: boolean, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public enableDisableVoucherPratica(id_slug_comune: string, codicePratica: string, codiceVoucher: string, enable: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public enableDisableVoucherPratica(id_slug_comune: string, codicePratica: string, codiceVoucher: string, enable: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public enableDisableVoucherPratica(id_slug_comune: string, codicePratica: string, codiceVoucher: string, enable: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling enableDisableVoucherPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling enableDisableVoucherPratica.');
        }

        if (codiceVoucher === null || codiceVoucher === undefined) {
            throw new Error('Required parameter codiceVoucher was null or undefined when calling enableDisableVoucherPratica.');
        }

        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling enableDisableVoucherPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enable !== undefined && enable !== null) {
            queryParameters = queryParameters.set('enable', <any>enable);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/voucher/${encodeURIComponent(String(codiceVoucher))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di generare i voucher per le pratiche con codice inviato in input
     * 
     * @param body 
     * @param id_slug_comune 
     * @param invia_comunicazioni 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generaEdInviaVouchersManuali(body: Array<string>, id_slug_comune: string, invia_comunicazioni?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public generaEdInviaVouchersManuali(body: Array<string>, id_slug_comune: string, invia_comunicazioni?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public generaEdInviaVouchersManuali(body: Array<string>, id_slug_comune: string, invia_comunicazioni?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public generaEdInviaVouchersManuali(body: Array<string>, id_slug_comune: string, invia_comunicazioni?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling generaEdInviaVouchersManuali.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling generaEdInviaVouchersManuali.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (invia_comunicazioni !== undefined && invia_comunicazioni !== null) {
            queryParameters = queryParameters.set('invia_comunicazioni', <any>invia_comunicazioni);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/vouchers/genera-manualmente`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di generare i voucher per le pratiche ammesse/finanziate
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateVouchers(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public generateVouchers(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public generateVouchers(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public generateVouchers(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling generateVouchers.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/vouchers/genera`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di generare i voucher per le pratiche accettate quando il tipo pratica è cedole librarie
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateVouchersCedole(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public generateVouchersCedole(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public generateVouchersCedole(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public generateVouchersCedole(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling generateVouchersCedole.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/vouchers/cedole/genera`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di recuperare una singola pratica accettata a partire dal codice pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAcceptedPraticaByCodice(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public getAcceptedPraticaByCodice(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public getAcceptedPraticaByCodice(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public getAcceptedPraticaByCodice(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAcceptedPraticaByCodice.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getAcceptedPraticaByCodice.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/from/${encodeURIComponent(String(codicePratica))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricercare le pratiche
     * 
     * @param id_slug_comune 
     * @param page 
     * @param size 
     * @param codice_pratica 
     * @param status 
     * @param lock_status 
     * @param codice_anpr 
     * @param codice_fiscale 
     * @param nome 
     * @param cognome 
     * @param tipologia_pratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll2(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaStatus, lock_status?: boolean, codice_anpr?: string, codice_fiscale?: string, nome?: string, cognome?: string, tipologia_pratica?: TipologiaPratica, observe?: 'body', reportProgress?: boolean): Observable<PagePratica>;
    public getAll2(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaStatus, lock_status?: boolean, codice_anpr?: string, codice_fiscale?: string, nome?: string, cognome?: string, tipologia_pratica?: TipologiaPratica, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PagePratica>>;
    public getAll2(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaStatus, lock_status?: boolean, codice_anpr?: string, codice_fiscale?: string, nome?: string, cognome?: string, tipologia_pratica?: TipologiaPratica, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PagePratica>>;
    public getAll2(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaStatus, lock_status?: boolean, codice_anpr?: string, codice_fiscale?: string, nome?: string, cognome?: string, tipologia_pratica?: TipologiaPratica, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAll2.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getAll2.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (codice_pratica !== undefined && codice_pratica !== null) {
            queryParameters = queryParameters.set('codice_pratica', <any>codice_pratica);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (lock_status !== undefined && lock_status !== null) {
            queryParameters = queryParameters.set('lock_status', <any>lock_status);
        }
        if (codice_anpr !== undefined && codice_anpr !== null) {
            queryParameters = queryParameters.set('codice_anpr', <any>codice_anpr);
        }
        if (codice_fiscale !== undefined && codice_fiscale !== null) {
            queryParameters = queryParameters.set('codice_fiscale', <any>codice_fiscale);
        }
        if (nome !== undefined && nome !== null) {
            queryParameters = queryParameters.set('nome', <any>nome);
        }
        if (cognome !== undefined && cognome !== null) {
            queryParameters = queryParameters.set('cognome', <any>cognome);
        }
        if (tipologia_pratica !== undefined && tipologia_pratica !== null) {
            queryParameters = queryParameters.set('tipologia_pratica', <any>tipologia_pratica);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PagePratica>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricercare le pratiche
     * 
     * @param id_slug_comune 
     * @param from 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllByUpdatedAt(id_slug_comune: string, from: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<Pratica>>;
    public getAllByUpdatedAt(id_slug_comune: string, from: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Pratica>>>;
    public getAllByUpdatedAt(id_slug_comune: string, from: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Pratica>>>;
    public getAllByUpdatedAt(id_slug_comune: string, from: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAllByUpdatedAt.');
        }

        if (from === null || from === undefined) {
            throw new Error('Required parameter from was null or undefined when calling getAllByUpdatedAt.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Pratica>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/from`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ottenere le informazioni relative al voucher ed alle transazioni effettuate a partire dal codice pratica e codice fiscale
     * 
     * @param id_slug_comune 
     * @param codiceFiscale 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAnagraficaCittadinoAndTransazioni(id_slug_comune: string, codiceFiscale: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<CittadinoTransazioniDTO>;
    public getAnagraficaCittadinoAndTransazioni(id_slug_comune: string, codiceFiscale: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CittadinoTransazioniDTO>>;
    public getAnagraficaCittadinoAndTransazioni(id_slug_comune: string, codiceFiscale: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CittadinoTransazioniDTO>>;
    public getAnagraficaCittadinoAndTransazioni(id_slug_comune: string, codiceFiscale: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAnagraficaCittadinoAndTransazioni.');
        }

        if (codiceFiscale === null || codiceFiscale === undefined) {
            throw new Error('Required parameter codiceFiscale was null or undefined when calling getAnagraficaCittadinoAndTransazioni.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getAnagraficaCittadinoAndTransazioni.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CittadinoTransazioniDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codiceFiscale))}/info/${encodeURIComponent(String(codicePratica))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare un documento allegato alla pratica
     * @param id_slug_comune 
     * @param codicePratica 
     * @param nomeFile 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDocumentoPratica(id_slug_comune: string, codicePratica: string, nomeFile: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getDocumentoPratica(id_slug_comune: string, codicePratica: string, nomeFile: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getDocumentoPratica(id_slug_comune: string, codicePratica: string, nomeFile: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getDocumentoPratica(id_slug_comune: string, codicePratica: string, nomeFile: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getDocumentoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getDocumentoPratica.');
        }

        if (nomeFile === null || nomeFile === undefined) {
            throw new Error('Required parameter nomeFile was null or undefined when calling getDocumentoPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nomeFile !== undefined && nomeFile !== null) {
            queryParameters = queryParameters.set('nomeFile', <any>nomeFile);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/documento`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il pdf della pratica
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPdfPratica(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getPdfPratica(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getPdfPratica(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getPdfPratica(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPdfPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPdfPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/pdfPratica`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il pdf della pratica
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPdfPraticaAttuale(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getPdfPraticaAttuale(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getPdfPraticaAttuale(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getPdfPraticaAttuale(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPdfPraticaAttuale.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPdfPraticaAttuale.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/pdfPraticaAttuale`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare il pdf review della pratica
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getPdfReviewPratica(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPdfReviewPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPdfReviewPratica.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/pdf-review-pratica`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricevere il dettaglio di una pratica a partire dal codice pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPratica(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public getPratica(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public getPratica(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public getPratica(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricevere la lista delle pratiche in conflitto con quella richiesta (per CF o ANPR)
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPraticheInConflitto(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Pratica>>;
    public getPraticheInConflitto(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Pratica>>>;
    public getPraticheInConflitto(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Pratica>>>;
    public getPraticheInConflitto(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPraticheInConflitto.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPraticheInConflitto.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Pratica>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/conflitti`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di visualizzare le statistiche relative allo stato delle domande sottomesse
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPraticheStats(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<PraticheStatsDTO>;
    public getPraticheStats(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PraticheStatsDTO>>;
    public getPraticheStats(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PraticheStatsDTO>>;
    public getPraticheStats(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPraticheStats.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PraticheStatsDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/stats/get`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare un file zip contenente i pdf di tutte le pratiche
     * @param id_slug_comune 
     * @param page 
     * @param size 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getZipPratiche(id_slug_comune: string, page?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getZipPratiche(id_slug_comune: string, page?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getZipPratiche(id_slug_comune: string, page?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getZipPratiche(id_slug_comune: string, page?: number, size?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getZipPratiche.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/pdfPratiche/export`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ottenere le informazioni circa le comunicazione inviate ed il loro stato per le pratiche
     * 
     * @param id_slug_comune 
     * @param page 
     * @param size 
     * @param codice_pratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public infoComunicazioniVouchers(id_slug_comune: string, page?: number, size?: number, codice_pratica?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ComunicazioniPraticaDTO>>;
    public infoComunicazioniVouchers(id_slug_comune: string, page?: number, size?: number, codice_pratica?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ComunicazioniPraticaDTO>>>;
    public infoComunicazioniVouchers(id_slug_comune: string, page?: number, size?: number, codice_pratica?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ComunicazioniPraticaDTO>>>;
    public infoComunicazioniVouchers(id_slug_comune: string, page?: number, size?: number, codice_pratica?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling infoComunicazioniVouchers.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (codice_pratica !== undefined && codice_pratica !== null) {
            queryParameters = queryParameters.set('codice_pratica', <any>codice_pratica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ComunicazioniPraticaDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/vouchers/infoComunicazioni`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di fare il lock o l&#x27;unlock di una pratica. Se il parametro unlock non viene passato viene impostato di default a true
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param unlock 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lockUnlockPratica(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public lockUnlockPratica(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public lockUnlockPratica(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public lockUnlockPratica(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling lockUnlockPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling lockUnlockPratica.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (unlock !== undefined && unlock !== null) {
            queryParameters = queryParameters.set('unlock', <any>unlock);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/unlock`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiungere/modificare il codice anpr di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param codiceAnpr 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchCodiceAnpr(id_slug_comune: string, codicePratica: string, codiceAnpr: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchCodiceAnpr(id_slug_comune: string, codicePratica: string, codiceAnpr: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchCodiceAnpr(id_slug_comune: string, codicePratica: string, codiceAnpr: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchCodiceAnpr(id_slug_comune: string, codicePratica: string, codiceAnpr: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchCodiceAnpr.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchCodiceAnpr.');
        }

        if (codiceAnpr === null || codiceAnpr === undefined) {
            throw new Error('Required parameter codiceAnpr was null or undefined when calling patchCodiceAnpr.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codiceAnpr !== undefined && codiceAnpr !== null) {
            queryParameters = queryParameters.set('codiceAnpr', <any>codiceAnpr);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/codiceAnpr`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente il contributo di una pratica
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchContributoPratica(body: AggiornamentoContributoDTO, id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchContributoPratica(body: AggiornamentoContributoDTO, id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchContributoPratica(body: AggiornamentoContributoDTO, id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchContributoPratica(body: AggiornamentoContributoDTO, id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchContributoPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchContributoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchContributoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/contributoPratica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente i dati di un elemento del nucleo familiare di una pratica. Se esiste un voucher collegato viene modificato anche il cf nel voucher
     * 
     * @param body 
     * @param idElementoNucleo 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchElementoNucleoPratica(body: UpdateElementoNucleoDTO, idElementoNucleo: string, id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchElementoNucleoPratica(body: UpdateElementoNucleoDTO, idElementoNucleo: string, id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchElementoNucleoPratica(body: UpdateElementoNucleoDTO, idElementoNucleo: string, id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchElementoNucleoPratica(body: UpdateElementoNucleoDTO, idElementoNucleo: string, id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchElementoNucleoPratica.');
        }

        if (idElementoNucleo === null || idElementoNucleo === undefined) {
            throw new Error('Required parameter idElementoNucleo was null or undefined when calling patchElementoNucleoPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchElementoNucleoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchElementoNucleoPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idElementoNucleo !== undefined && idElementoNucleo !== null) {
            queryParameters = queryParameters.set('idElementoNucleo', <any>idElementoNucleo);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/elementoNucleo`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente un extra field dell&#x27;anagrafica di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param extra_field_key 
     * @param extra_field_value 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchExtraFieldAnagraficaPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchExtraFieldAnagraficaPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchExtraFieldAnagraficaPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchExtraFieldAnagraficaPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchExtraFieldAnagraficaPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchExtraFieldAnagraficaPratica.');
        }

        if (extra_field_key === null || extra_field_key === undefined) {
            throw new Error('Required parameter extra_field_key was null or undefined when calling patchExtraFieldAnagraficaPratica.');
        }

        if (extra_field_value === null || extra_field_value === undefined) {
            throw new Error('Required parameter extra_field_value was null or undefined when calling patchExtraFieldAnagraficaPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (extra_field_key !== undefined && extra_field_key !== null) {
            queryParameters = queryParameters.set('extra_field_key', <any>extra_field_key);
        }
        if (extra_field_value !== undefined && extra_field_value !== null) {
            queryParameters = queryParameters.set('extra_field_value', <any>extra_field_value);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/anagraficaExtraField`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente un extra field di un elemento del nucleo familiare di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idElementoNucleo 
     * @param extra_field_key 
     * @param extra_field_value 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchExtraFieldElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, extra_field_key: string, extra_field_value: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchExtraFieldElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, extra_field_key: string, extra_field_value: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchExtraFieldElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, extra_field_key: string, extra_field_value: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchExtraFieldElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, extra_field_key: string, extra_field_value: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchExtraFieldElementoNucleoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchExtraFieldElementoNucleoPratica.');
        }

        if (idElementoNucleo === null || idElementoNucleo === undefined) {
            throw new Error('Required parameter idElementoNucleo was null or undefined when calling patchExtraFieldElementoNucleoPratica.');
        }

        if (extra_field_key === null || extra_field_key === undefined) {
            throw new Error('Required parameter extra_field_key was null or undefined when calling patchExtraFieldElementoNucleoPratica.');
        }

        if (extra_field_value === null || extra_field_value === undefined) {
            throw new Error('Required parameter extra_field_value was null or undefined when calling patchExtraFieldElementoNucleoPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idElementoNucleo !== undefined && idElementoNucleo !== null) {
            queryParameters = queryParameters.set('idElementoNucleo', <any>idElementoNucleo);
        }
        if (extra_field_key !== undefined && extra_field_key !== null) {
            queryParameters = queryParameters.set('extra_field_key', <any>extra_field_key);
        }
        if (extra_field_value !== undefined && extra_field_value !== null) {
            queryParameters = queryParameters.set('extra_field_value', <any>extra_field_value);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/elementoNucleoExtraField`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente un extra field di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param extra_field_key 
     * @param extra_field_value 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchExtraFieldPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchExtraFieldPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchExtraFieldPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchExtraFieldPratica(id_slug_comune: string, codicePratica: string, extra_field_key: string, extra_field_value: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchExtraFieldPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchExtraFieldPratica.');
        }

        if (extra_field_key === null || extra_field_key === undefined) {
            throw new Error('Required parameter extra_field_key was null or undefined when calling patchExtraFieldPratica.');
        }

        if (extra_field_value === null || extra_field_value === undefined) {
            throw new Error('Required parameter extra_field_value was null or undefined when calling patchExtraFieldPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (extra_field_key !== undefined && extra_field_key !== null) {
            queryParameters = queryParameters.set('extra_field_key', <any>extra_field_key);
        }
        if (extra_field_value !== undefined && extra_field_value !== null) {
            queryParameters = queryParameters.set('extra_field_value', <any>extra_field_value);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/extraField`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente l&#x27;isee di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param isee 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchIseePratica(id_slug_comune: string, codicePratica: string, isee: number, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchIseePratica(id_slug_comune: string, codicePratica: string, isee: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchIseePratica(id_slug_comune: string, codicePratica: string, isee: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchIseePratica(id_slug_comune: string, codicePratica: string, isee: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchIseePratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchIseePratica.');
        }

        if (isee === null || isee === undefined) {
            throw new Error('Required parameter isee was null or undefined when calling patchIseePratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isee !== undefined && isee !== null) {
            queryParameters = queryParameters.set('isee', <any>isee);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/iseePratica`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente il campo non autosufficiente di un elemento del nucleo familiare di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param idElementoNucleo 
     * @param nonAutosufficiente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchNonAutosufficienteElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, nonAutosufficiente: boolean, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchNonAutosufficienteElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, nonAutosufficiente: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchNonAutosufficienteElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, nonAutosufficiente: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchNonAutosufficienteElementoNucleoPratica(id_slug_comune: string, codicePratica: string, idElementoNucleo: string, nonAutosufficiente: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchNonAutosufficienteElementoNucleoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchNonAutosufficienteElementoNucleoPratica.');
        }

        if (idElementoNucleo === null || idElementoNucleo === undefined) {
            throw new Error('Required parameter idElementoNucleo was null or undefined when calling patchNonAutosufficienteElementoNucleoPratica.');
        }

        if (nonAutosufficiente === null || nonAutosufficiente === undefined) {
            throw new Error('Required parameter nonAutosufficiente was null or undefined when calling patchNonAutosufficienteElementoNucleoPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idElementoNucleo !== undefined && idElementoNucleo !== null) {
            queryParameters = queryParameters.set('idElementoNucleo', <any>idElementoNucleo);
        }
        if (nonAutosufficiente !== undefined && nonAutosufficiente !== null) {
            queryParameters = queryParameters.set('nonAutosufficiente', <any>nonAutosufficiente);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/elementoNucleoNonAutosufficiente`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare forzatamente il punteggio di una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param punteggio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchPunteggioPratica(id_slug_comune: string, codicePratica: string, punteggio: number, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public patchPunteggioPratica(id_slug_comune: string, codicePratica: string, punteggio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public patchPunteggioPratica(id_slug_comune: string, codicePratica: string, punteggio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public patchPunteggioPratica(id_slug_comune: string, codicePratica: string, punteggio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling patchPunteggioPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling patchPunteggioPratica.');
        }

        if (punteggio === null || punteggio === undefined) {
            throw new Error('Required parameter punteggio was null or undefined when calling patchPunteggioPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (punteggio !== undefined && punteggio !== null) {
            queryParameters = queryParameters.set('punteggio', <any>punteggio);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/punteggioPratica`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di reinviare il pdf della pratica
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reinviaPdfPratica(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public reinviaPdfPratica(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public reinviaPdfPratica(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public reinviaPdfPratica(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling reinviaPdfPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling reinviaPdfPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/reinviaPdfPratica`,
            {
             responseType: "blob" as "json",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricalcolare i punteggi e gli importi di un determinato tipo di pratica (se lo stato del tipo pratica lo consente)
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricalcolaPunteggiEdImporti(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public ricalcolaPunteggiEdImporti(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public ricalcolaPunteggiEdImporti(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public ricalcolaPunteggiEdImporti(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling ricalcolaPunteggiEdImporti.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/ricalcolaPunteggiEdImporti`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricalcolare i punteggi e gli importi di un determinato tipo di pratica (se lo stato del tipo pratica lo consente)
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricalcolaPunteggioEdImportoPratica(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public ricalcolaPunteggioEdImportoPratica(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public ricalcolaPunteggioEdImportoPratica(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public ricalcolaPunteggioEdImportoPratica(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling ricalcolaPunteggioEdImportoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling ricalcolaPunteggioEdImportoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/ricalcolaPunteggioEdImporto`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di richiedere un nuovo otp relativo ad una pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param tipo_ricezione_otp 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public richiediOtpPratica(id_slug_comune: string, codicePratica: string, tipo_ricezione_otp: TipoRicezioneOTP, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public richiediOtpPratica(id_slug_comune: string, codicePratica: string, tipo_ricezione_otp: TipoRicezioneOTP, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public richiediOtpPratica(id_slug_comune: string, codicePratica: string, tipo_ricezione_otp: TipoRicezioneOTP, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public richiediOtpPratica(id_slug_comune: string, codicePratica: string, tipo_ricezione_otp: TipoRicezioneOTP, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling richiediOtpPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling richiediOtpPratica.');
        }

        if (tipo_ricezione_otp === null || tipo_ricezione_otp === undefined) {
            throw new Error('Required parameter tipo_ricezione_otp was null or undefined when calling richiediOtpPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tipo_ricezione_otp !== undefined && tipo_ricezione_otp !== null) {
            queryParameters = queryParameters.set('tipo_ricezione_otp', <any>tipo_ricezione_otp);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/richiedi-otp`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiornare lo stato di una pratica. Opzionalmente è possibile passare una nota o (nel caso in cui è abilitata la gestione) il codice anpr
     * 
     * @param body 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStatoPratica(body: UpdateStatoPraticaDTO, id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Pratica>;
    public updateStatoPratica(body: UpdateStatoPraticaDTO, id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Pratica>>;
    public updateStatoPratica(body: UpdateStatoPraticaDTO, id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Pratica>>;
    public updateStatoPratica(body: UpdateStatoPraticaDTO, id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateStatoPratica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling updateStatoPratica.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling updateStatoPratica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Pratica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche/${encodeURIComponent(String(codicePratica))}/updateStato`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
